import CityPageTemplate from "../city-template/CityPageTemplate";
import { mountainViewConfig } from "./data";

export default function MountainViewPage() {
  return <CityPageTemplate config={mountainViewConfig} />;
}